import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/menu-select.png'


_pushScopeId("data-v-cd87e578")
const _hoisted_1 = { class: "menu-container" }
const _hoisted_2 = ["onClick", "id"]
const _hoisted_3 = { class: "menu-content" }
const _hoisted_4 = { class: "img" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (item.visible)
          ? (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.handleMenuSelect(item)),
              key: index,
              class: "menu-item",
              id: _ctx.setStepId(item)
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (item.isSelect)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : _createCommentVNode("", true),
                  _createElementVNode("i", {
                    class: _normalizeClass([item.icon, 'menu-icon', { 'menu-icon-select': item.isSelect }]),
                    style: _normalizeStyle({
                marginLeft: item.isSelect ? '4px' : '21px',
              })
                  }, null, 6)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(item.isSelect ? 'menu-isSelect' : 'menu-title')
                }, _toDisplayString(item.title), 3)
              ])
            ], 8, _hoisted_2))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
}